import React, { useEffect, useState } from "react";
// import "./login.css";
import Helmet from "../../components/Helmet";
import { ClipLoader } from "react-spinners";
import "react-toastify/dist/ReactToastify.css";
import { userLoginFormValidation } from "../../components/LoginValidation";
import { ToastContainer, toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import FrontendLayout from "../../layouts/FrontendLayout";
import api from "../../api/axiosInstance";

const UserLogin = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    sol_roll_no: "",
    password: "",
  });
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  const userLoggedin = async (e) => {
    e.preventDefault();

    const validationErrors = userLoginFormValidation(formData);
    console.log(validationErrors);
    setErrors(validationErrors);
    console.log(errors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setLoading(true);

      const res = await api.post("/login", formData);
      const { token, form_status } = res.data.data;

      localStorage.setItem("token", token);

      if (res.data.data.final_submit === 1) {
        navigate("/completed");
        return;
      } else if (form_status === 1) {
        navigate("/preview");
      } else if (form_status === 2) {
        navigate("/fullPreview");
      } else {
        navigate("/personal");
      }
    } catch (error) {
      console.error(error);

      if (error.response?.data?.message) {
        if (error.response?.data?.errors) {
          const apiErrors = {};
          Object.keys(error.response.data.errors).forEach((key) => {
            apiErrors[key] = error.response.data.errors[key].msg;
          });
          setErrors(apiErrors);
          toast.error(error.response.data.message);
          return;
        }
        toast.error(error.response.data.message);
        return;
      }

      toast.error("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 1️⃣ Clear token on login page
    localStorage.removeItem("token");
    localStorage.removeItem("logoutReason");

    // 2️⃣ Existing code: block back button if logged in
    const token = localStorage.getItem("token");
    if (token) {
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
        window.history.pushState(null, "", window.location.href);
      };
    }

    // 3️⃣ Show logout reason if exists
    const reason = localStorage.getItem("logoutReason");
    if (reason) {
      toast.error(reason);
      setTimeout(() => {
        localStorage.removeItem("logoutReason");
      }, 4000);
    }
  }, []);

  return (
    <div className="login-wrapper d-flex align-items-center justify-content-center">
      <FrontendLayout />

      <Helmet title="Login" />
      <ToastContainer position="top-center" autoClose={3000} />

      {loading && (
        <div className="full-page-loader">
          <ClipLoader size={60} color="#0d6efd" />
        </div>
      )}

      {/* Main Card Container - 90% width on small, capped on large */}
      <div className=" container-fluid">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-10">
            <div className="card border-0 shadow-lg overflow-hidden login-main-card">
              <div className="row g-0">
                {/* LEFT SIDE*/}
                <div className="col-md-8 bg-primary text-white d-flex align-items-center justify-content">
                  <div className="p-5 w-100">
                    <h2 className="fw-bold mb-4 text-center">
                      Financial Support Scheme(FSS) 2026-27{" "}
                    </h2>
                    <p className="text-white justify-content">
                      The Department of Distance & Education, School of Open
                      Learning, Campus of Open Learning (DDCE/SOL/COL) in the
                      spirit to facilitate financially weak students as per
                      guidelines decided by the University of Delhi, is
                      announced Financial Support Scheme for DDCE/SOL/COL
                      students. This scheme is reflected through a fee
                      waiver/refund for the students enrolled in DDCE/SOL/COL
                      and having their family income below the poverty line. The
                      fee waiver/refund includes all components of the fee paid
                      by students except Examination fee and University
                      Fee.{" "}
                    </p>
                    <p className="text-white justify-content">
                      To avail Financial Support Scheme in term of Fee Waiver.
                      The student has to determine the following.{" "}
                    </p>
                    <br></br>
                    <h6>Eligibility:</h6>
                    <p className="text-white justify-content">
                      A student studying in DDCE/SOL/COL University of Delhi and
                      his/her Annual Family Income falling in mentioned
                      categories eligible to apply.
                    </p>

                    <p className="text-white justify-content">
                      2nd, 3rd & 4th year candidates with ER/Arrears of previous
                      examination papers are not eligible to apply.
                    </p>
                    <br />
                    <h6>Documents required:</h6>
                    <p className="text-white justify-content">
                      1.Candidate Photo <br></br>2.Candidate Signature <br></br>
                      3. Annual family income Certificate issued by Govt. office
                      for the current financial year issued after 31st March
                      2026.<br></br>4. Copy of current Fee Receipt.<br></br> 5.
                      Copy of Marksheet of the last exam passed. (Not Applicable
                      for 1st Year) <br></br>6. Cancelled Cheque/Copy of Bank
                      Passbook showing the student Name, Account Number and IFSC
                      code. (Aadhar seeded Bank Account)<br></br> 7.Undertaking duly signed by the student regarding status of employment of the student : Employed/Unemployed/Self Employed
                    </p>
                    <br />
                    <h6>Important:</h6>
                    <p className="text-white justify-content">
                      1. SOL may impose an additional condition to decide the
                      merit if required.
                      <br></br>2. The Fee Waiver is year wise. For every
                      successful year applicant has to apply afresh.<br></br>3. The online application process starts on 03.11.2026.<br></br>4.
                      Last date to submit the online application is 20.11.2026
                    </p>
                  </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="col-md-4 bg-white" style={{ paddingTop: "5%" }}>
                  <div className="card-body p-4 p-lg-5">
                    <div className="text-center text-md-start mb-3">
                      <h3 className="fw-bold text-dark">Sign In</h3>
                      <p className="text-muted">
                        Enter your SOL credentials below
                      </p>
                    </div>

                    <form onSubmit={userLoggedin}>
                      <div className="mb-4">
                        <label className="form-label fw-bold small text-uppercase text-muted">
                          SOL Roll Number
                        </label>
                        <input
                          type="text"
                          name="sol_roll_no"
                          className={`form-control form-control-lg bg-light ${
                            errors.sol_roll_no ? "is-invalid" : ""
                          }`}
                          placeholder="Enter SOL Roll Number"
                          onChange={handleChange}
                          style={{ fontSize: "0.95rem" }}
                        />
                        {errors.sol_roll_no && (
                          <div className="invalid-feedback">
                            {errors.sol_roll_no}
                          </div>
                        )}
                      </div>

                      <div className="mb-4">
                        <label className="form-label fw-bold small text-uppercase text-muted">
                          Barcode / Control Number
                        </label>

                        <div className="position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            className={`form-control form-control-lg bg-light pe-5 ${
                              errors.password ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Barcode / Control Number"
                            onChange={handleChange}
                            style={{ fontSize: "0.95rem" }}
                          />

                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "15px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              fontSize: "1.2rem",
                              color: "#6c757d",
                            }}
                          >
                            {showPassword ? "🙈" : "👁️"}
                          </span>
                        </div>

                        {errors.password && (
                          <div className="invalid-feedback d-block">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      <div className="mb-2 fw-bold text-center">
                        <a
                          href="https://web.sol.du.ac.in/misc/student_info/"
                          style={{ cursor: "pointer" }}
                        >
                          <b>Know Your Barcode</b>
                        </a>
                      </div>

                      <div className="d-grid gap-2 pt-2">
                        <button
                          type="submit"
                          className="btn btn-primary  shadow-sm fw-bold"
                          style={{
                            borderRadius: "10px",
                            padding: "12px",
                            width: "100%",
                          }}
                        >
                          Sign In
                        </button>
                      </div>

                      <div className="d-grid gap-2 pt-2">
                        <p className="mt-4 text-center">
                          &copy; {new Date().getFullYear()} Open Learning Development Centre(OLDC). 
                          All rights reserved. 
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
